import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  ypos: Event | Number | undefined;

  constructor() { }

  shrinkNav(Ypos: Event | Number) {
    this.ypos = Ypos;
  }
}
